import { render, staticRenderFns } from "./Cribbage.vue?vue&type=template&id=6cef1986"
import script from "./Cribbage.vue?vue&type=script&lang=js"
export * from "./Cribbage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports